
// 个人中心页面——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `page/personalCenter/index${i + 1}`,
  name: `page/personalCenterIndex${i + 1}`,
  component: () => import(`@/views/recognize/page/personalCenter/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [

    // 个人中心页面——主流程，开始
    ...MainRoutes
  ]
}
